import React from "react";

export const formattedDate = (date) => {
  const formattedAccountDate = new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
  });
  return formattedAccountDate;
};

export const formattedTime = (time) => {
  const date = new Date(time);
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return formattedTime;
};

export const toCurrencyNumber = (value) => {
  const num = Number(String(value ?? 0).replace(/[^0-9.-]+/g, ""));
  if (!Number.isFinite(num)) return 0;
  return Math.round(num * 100) / 100;
};

export const getPaymentAppliedDisplayTotal = (payment) =>
  toCurrencyNumber(
    toCurrencyNumber(payment?.AppliedTotal) +
      toCurrencyNumber(payment?.CardProcessingFee) +
      toCurrencyNumber(payment?.BankProcessingFee),
  );

// Always renders cents, so amounts never collapse to "$46,022" or "$1,234.5".
export const formatCurrency = (value) =>
  `$${toCurrencyNumber(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const renderCommentWithTag = (text, taggedUser) => {
  if (!taggedUser) return text;

  const tag = `@${taggedUser}`;
  const parts = text.split(tag);
  console.log(parts, tag, "values on tagged name >>>>>");
  return (
    <>
      {parts[0]}
      <span className="comment-with-tag-text">{tag}</span>
      {parts.slice(1).join(tag)}
    </>
  );
};
